module.exports = __webpack_public_path__ + "static/media/rCasey.605763f0.jpeg";